export default __webpack_public_path__ + "static/media/brave.40871e0a.svg";